// Feature flags the editor guarantees with fixed display names, applied on top of
// whatever GET /feature-flags returns: missing flags are added, differing titles
// are overridden. Toggled per-organisation via the standard feature_flags path.
const OVERRIDE_FEATURE_FLAGS = [
  { _id: 'web_builder_access_enabled', title: 'Web Builder Access', default_value: false, pro: false },
  { _id: 'has_bespoke', title: 'Bespoke Website', default_value: false, pro: false }
];

export const mergeFeatureFlagCatalogue = featureFlags => {
  const pendingOverrides = new Map(OVERRIDE_FEATURE_FLAGS.map(flag => [flag._id, flag]));
  const withOverrides = (featureFlags ?? []).map(featureFlag => {
    const override = pendingOverrides.get(featureFlag._id);
    if (!override) return featureFlag;
    pendingOverrides.delete(featureFlag._id);
    return { ...featureFlag, title: override.title };
  });
  return [...withOverrides, ...pendingOverrides.values()];
};
